import React, { useState } from "react";
import AddUser from "./AddUser";
import UserLocationSmtp from "./UserLocationSmtp";

export default function AddEditUserLayout({
  id,
  setShowAddUser,
  setSelectedUser,
  selectedUser,
}) {
  /* ******************** All States ************************* */
  const [selectedTab, setSelectedTab] = useState("user-info");

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div>
      {/* Tabs Btn-Group */}
      <div className="d-flex">
        <div className="btn-group d-flex justify-content-start">
          <button
            onClick={() => setSelectedTab("user-info")}
            className={`btn shadow-sm ${
              selectedTab === "user-info" ? "btn-primary" : "bg-white"
            }`}
          >
            User Info
          </button>
          <button
            onClick={() => setSelectedTab("user-smtp")}
            className={`btn shadow-sm ${
              selectedTab === "user-smtp" ? "btn-primary" : "bg-white"
            }`}
          >
            SMTP
          </button>
        </div>
      </div>
      <hr />
      <div>
        {/* Tab Content */}
        <div>
          {selectedTab === "user-info" && (
            <AddUser
              id={selectedUser?.id}
              setShowAddUser={setShowAddUser}
              setSelectedUser={setSelectedUser}
              selectedUser={selectedUser}
            />
          )}
          {selectedTab === "user-smtp" && (
            <div className="">
              <UserLocationSmtp selectedUser={selectedUser} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
